import React from 'react';
import { JsonLd } from 'react-schemaorg';
import routes from '@achievable-me/tundra-wizard/routes';
import { reverse } from 'named-urls';

const SeoBreadcrumbs = ({ contentInstance, product }) => {
  const itemListElement = [
    {
      '@type': 'ListItem',
      position: 1,
      name: product.name,
      item: `https://app.achievable.me${reverse(routes.study.overview, {
        productSlug: product.slug,
      })}`,
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: contentInstance.name,
    },
  ];

  return (
    <JsonLd
      item={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement,
      }}
    />
  );
};

export default SeoBreadcrumbs;
